interface UtilityBtnProps {
  onClickHandler: () => void;
  text: string;
  classNames?: Partial<UtilityButtonClasses>;
}

interface UtilityButtonClasses {
  root: string;
  color: string;
  container: string;
}

export default function UtilityBtn({
  classNames,
  text,
  onClickHandler,
}: UtilityBtnProps) {
  return (
    <div
      className={[
        classNames && classNames.container
          ? classNames.container
          : `utility-button__container`,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <button
        className={[
          classNames && classNames.root
            ? classNames.root
            : `utility-button__root`,
          classNames && classNames.color
            ? classNames.color
            : "utility-button--grey",
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={onClickHandler}
      >
        <span>{text}</span>
      </button>
    </div>
  );
}
